import '@/App.css';
import { Routes, Route } from 'react-router-dom';
import { SiteLayout } from '@/components/layout/SiteLayout';
import HomePage from '@/pages/HomePage';
import ToolsHubPage from '@/pages/ToolsHubPage';
import WordToPdfPage from '@/pages/tools/WordToPdfPage';
import JpgToPngPage from '@/pages/tools/JpgToPngPage';
import ImageCompressorPage from '@/pages/tools/ImageCompressorPage';
import ResizeImagePage from '@/pages/tools/ResizeImagePage';
import WordCounterPage from '@/pages/tools/WordCounterPage';
import CaseConverterPage from '@/pages/tools/CaseConverterPage';
import LoremIpsumPage from '@/pages/tools/LoremIpsumPage';
import TimerPage from '@/pages/tools/TimerPage';
import QrGeneratorPage from '@/pages/tools/QrGeneratorPage';
import ThumbnailDownloaderPage from '@/pages/tools/ThumbnailDownloaderPage';
import PageSpeedPage from '@/pages/tools/PageSpeedPage';
import ComingSoonToolPage from '@/pages/tools/ComingSoonToolPage';
import BlogListPage from '@/pages/BlogListPage';
import BlogPostPage from '@/pages/BlogPostPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import NotFoundPage from '@/pages/NotFoundPage';

function App() {
    return (
        <div className="App">
            <SiteLayout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/tools" element={<ToolsHubPage />} />
                    <Route path="/tools/word-to-pdf" element={<WordToPdfPage />} />
                    <Route path="/tools/jpg-to-png" element={<JpgToPngPage />} />
                    <Route path="/tools/image-compressor" element={<ImageCompressorPage />} />
                    <Route path="/tools/resize-image" element={<ResizeImagePage />} />
                    <Route path="/tools/word-counter" element={<WordCounterPage />} />
                    <Route path="/tools/case-converter" element={<CaseConverterPage />} />
                    <Route path="/tools/lorem-ipsum" element={<LoremIpsumPage />} />
                    <Route path="/tools/timer" element={<TimerPage />} />
                    <Route path="/tools/qr-generator" element={<QrGeneratorPage />} />
                    <Route path="/tools/thumbnail-downloader" element={<ThumbnailDownloaderPage />} />
                    <Route path="/tools/page-speed" element={<PageSpeedPage />} />
                    <Route path="/tools/:slug" element={<ComingSoonToolPage />} />
                    <Route path="/blog" element={<BlogListPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPage />} />
                    <Route path="/terms-of-service" element={<TermsPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </SiteLayout>
        </div>
    );
}

export default App;
